import React, { useContext } from 'react';
import { VectorType, type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { BaseToolbar } from '@/components/base-toolbar';
import { DividerLine } from '@/components/divider-line';
import { useBaseTool } from '@/hooks/use-common-tool';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { VectorPanelContext } from '../../context';
import {
    BlurController,
    BorderRadiusController,
    FillColorPicker,
    LayerOpacity,
    PieceColorPicker,
    ReflectionInspector,
    ShadowInspector,
    StrokeInspector,
} from '../../widgets';
import './style.less';

export const VectorImagePanel: React.FC = () => {
    const { layerId, recordId } = useContext(VectorPanelContext)!;

    const editor = useEditor();

    const baseTrackCallback = useBaseTool(editor, 9, recordId);

    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const parentId = layer.parentId;
        const layerData = layer.data as IVectorLayerProps;
        const { vectorType } = layerData;

        return {
            parentId,
            vectorType,
        };
    });

    const vectorType = props ? props.vectorType : VectorType.Rect;

    return (
        <div className="vector-image-panel">
            {vectorType === VectorType.Graph ? (
                <PieceColorPicker />
            ) : (
                <>
                    <div className="vector-image-panel__base">
                        <FillColorPicker />
                        <BlurController />
                        <LayerOpacity />
                        {vectorType === VectorType.Rect ? <BorderRadiusController /> : null}
                    </div>

                    <DividerLine />

                    <div className="vector-image-panel__effects">
                        <StrokeInspector />
                        <div className="vector-image-panel__divider" />
                        <ShadowInspector />
                        <div className="vector-image-panel__divider" />
                        <ReflectionInspector />
                    </div>
                </>
            )}

            <DividerLine />

            {/* 通用图层工具栏 */}
            <BaseToolbar id={layerId} editor={editor} style={{ padding: '0 16px 16px' }} {...baseTrackCallback} />
        </div>
    );
};
